import MVT from 'ol/format/MVT';
import TopoJSON from 'ol/format/TopoJSON';
import { MultiPoint, MultiLineString } from 'ol/geom';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import { Fill, RegularShape, Stroke, Style, Text, Icon, Circle } from 'ol/style';
import Snap from 'ol/interaction/Snap';
import Feature from 'ol/Feature';
import { CommonMapService } from './common-map.service';
import { AttrIndexService } from './attr-index.service';
import { colors, styleAttrs } from 'assets/TS/StyleConfig';
import { MapSharedService } from './map-shared.service';
import { MainDataService } from './main-data.service';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
import * as i2 from "./main-data.service";
import * as i3 from "./common-map.service";
import * as i4 from "./map-shared.service";
var MainDataMapLayersService = /** @class */ (function () {
    function MainDataMapLayersService(attrIndexService, mainDataService, cMapService, mapSharedService) {
        var _this = this;
        this.attrIndexService = attrIndexService;
        this.mainDataService = mainDataService;
        this.cMapService = cMapService;
        this.mapSharedService = mapSharedService;
        this.vectorTileRefLayerName = 'vectorTileRefLayer';
        this.bgSurroundingsLayerName = 'bgSurroundingsLayer'; // bgReferenceLayer
        this.bgReferenceLayerName = 'bgReferenceLayer';
        this.bgOptionalBdryLayerName = 'bgOptionalBdryLayer';
        // For EdgePoint data
        this.countyBoundaryLayerName = 'countyBoundaryLayer';
        this.countyBoundarySelfLayerName = 'countyBoundarySelfLayer';
        //
        this.dataLayerName = 'dataLayer';
        this.fishboneLayerName = 'fishboneLayer';
        this.interactiveFishboneLayerName = 'interactiveFishboneLayer';
        this.topoErrorLayerName = 'TopologyErrorLayer';
        this.topoResolvedLayerName = 'TopologyResolvedLayer';
        this.topojsonLayerName = 'topojsonLayer'; // 1.Display topology; 2.Modify
        this.addPolygonTempLayerName = 'polygonTemp';
        this.cursorLayerName = 'cursorLayer';
        this.qcErrorLayerName = 'qcErrorLayer';
        this.flashLayerName = 'flashLayer';
        this.dataModifyLayerName = 'dataModifyLayer';
        this.placeMarkerLayerName = 'placeMarkerLayer';
        this.ssapRclLinkLayerName = 'addressOnRoadFlashLayer';
        this.addressLineLayerName = 'addressLineLayer'; // For  address relocation & address assignment & a3i wizard & geom edit wizard use
        this.addressManageLayerName = 'addressManageLayer';
        this.addressRelocateHintLayerName = 'addressEditLineLayer';
        this.addrFishboneLayerName = 'addrFishboneLayer';
        this.addrBgFishboneLayerName = 'addrBgFishboneLayer';
        this.highlightLayerName = 'highlightLayer'; // used in polygon geom editing highlight
        this.bgReferenceEdgePointLayerName = 'BgMatchPointLayer';
        this.topojsonFormatLayer = 'topojsonInner';
        // 1.85, // scale bar is around 200m 
        this.labelResolution = {
            ADDPTS: 9,
            ROADCL: 2.5
        };
        this.labelPainterReso = 8;
        this.interactiveFishboneReso = 8;
        // TODO: combine with checkZoomLevelForTopoEditing
        this.editResolution = {
            ADDPTS: 0.9,
            ROADCL: 1.85 // scale bar is around 100m
        };
        // TODO
        this.refLayerResolution = {
            ADDPTS: 1.85,
            ROADCL: 2.5
        };
        this.refLayerReso_area = 80;
        this.refCenterlineResoAtBdryEdit = 20;
        this.fishboneReso = 1.85;
        this.getDataLayerStyle = function (feat, reso, labelLayer, modelKey) {
            var config = {
                strokeWidth: 1.5
            };
            var attr = _this.mainDataService.getDataAttrs(feat.getId()); // feat.getProperties()[this.attrIndexService.attrKey];
            var isDeleted = attr ? attr[_this.attrIndexService.isDeletedKey] : null;
            if (isDeleted) {
                config.strokeColor = colors.deleted;
                config.lineDash = styleAttrs.deletedLineDash;
            }
            var errLevel = attr ? attr[_this.attrIndexService.qaErrorLevelColName] : null;
            var styles = [];
            // Label style
            var geomType = feat.getGeometry().getType();
            if (geomType === 'Point') { //
                // Fishbone addr style
                var props = feat.getProperties();
                var fb = props[_this.attrIndexService.addrFishboneCol];
                var addrStyle = _this.getFishboneAddressStyle(fb, modelKey);
                if (addrStyle) {
                    styles.push(addrStyle);
                }
                else {
                    var dataStyles = _this.setEventLayerStyles(reso, feat, config, errLevel);
                    styles = styles.concat(dataStyles);
                }
                // Label
                if (labelLayer) {
                    if (_this.checkDrawAddrLabel(reso, labelLayer)) {
                        styles = styles.concat(_this.getAddressLabelStyle(attr));
                    }
                    if (feat.getProperties()[_this.attrIndexService.sameLocationKey]) {
                        styles.push(_this.getSameLocationPointStyle());
                    }
                }
            }
            else if (geomType === 'Polygon' || geomType === 'MultiPolygon') {
                config.strokeColor = 'rgb(255, 0, 0, 0.2)';
                config.lineDash = [6, 6];
                // Check for 4-color
                var props = feat.getProperties(); // do not use this.mainDataService.getDataAttrs here, it might not get updated yet
                config.fillColor = _this.mapSharedService.get4ColorBgColor(props);
                if (config.fillColor) {
                    config.fillColor += '40'; // add opacity
                }
                console.log(_this.mapSharedService.get4ColorBgColor(attr), feat.getId());
                styles.push(_this.cMapService.getCommonStyle(config));
            }
            else {
                var dataStyles = _this.setEventLayerStyles(reso, feat, config, errLevel);
                styles = styles.concat(dataStyles);
            }
            return styles;
        };
        // // TODO
        // getDataBgSurroundingLayerStyle = (feat, reso) => {
        // 	return this.setEventLayerStyles(reso, feat, {
        // 		imgFillColor: colors.mapSurroundingFill,
        // 		strokeColor: colors.mapSurroundingFill,
        // 		strokeWidth: 1,
        // 		pointRadius: 3,
        // 		label: {
        // 			offsetY: 10,
        // 			scale: 0.85
        // 		}
        // 	}, true)
        // }
        this.getDataBgLayerStyle = function (feat, reso, modelKey) {
            var styles = [];
            var config = {
                fillColor: colors.mapRefFill_alpha,
                imgFillColor: colors.mapSurroundingFill,
                strokeColor: colors.mapSurroundingFill,
                strokeWidth: 1,
                pointRadius: 3
            };
            var props = feat.getProperties();
            switch (feat.getGeometry().getType()) {
                // Use thinner stroke for polygon boundary
                case 'Polygon':
                case 'MultiPolygon':
                    config.strokeColor = 'rgb(255, 0, 0, 0.2)';
                    config.lineDash = [6, 6];
                    // Check for 4-color
                    // const bgColor = this.bgColorMap[props[this.attrIndexService.bdryColorCol]] || 'transparent';
                    config.fillColor = _this.mapSharedService.get4ColorBgColor(props);
                    ;
                    return [_this.cMapService.getCommonStyle(config)];
                case 'LineString':
                case 'MultiLineString':
                    config.strokeColor = colors.mapRefLine;
                    config.strokeWidth = 2;
                    var isMultiLine = feat.getGeometry().getType() === 'MultiLineString';
                    // Common style
                    styles = [_this.cMapService.getCommonStyle(config)];
                    // Arrow style
                    var as = _this.mapSharedService.getLineArrowStyle(feat, reso, isMultiLine, { color: config.strokeColor });
                    if (as) {
                        styles.push(as);
                    }
                    return styles;
                case 'Point':
                    // Fishbone addr style
                    var fb = props[_this.attrIndexService.addrFishboneCol];
                    var addrStyle = _this.getFishboneAddressStyle(fb, modelKey, true);
                    if (addrStyle) {
                        styles.push(addrStyle);
                    }
                    else {
                        styles = [_this.cMapService.getCommonStyle(config)];
                    }
                    return styles;
                default:
                    return [_this.cMapService.getCommonStyle(config)];
            }
        };
        this.getInteractiveFishboneStyle = function (feat, reso) {
            var imgFillColor = colors.mapFill;
            var strokeColor = colors.mapFill;
            // FSA/B is handled in another way currently
            // // Handle FSA/FSB separately
            // const props = feat.getProperties();
            // if (props[this.fishboneAttrKey]) {
            // 	const qaCode = props[this.fishboneAttrKey].fishboneQaCodes ? props[this.fishboneAttrKey].fishboneQaCodes.cd : null;
            // 	if (qaCode === 'FSA' || qaCode === 'FSB') {
            // 		strokeColor = colors.mapError;
            // 	}
            // }
            if (feat.getProperties()[_this.attrIndexService.isLongBoneKey] || feat.getProperties()[_this.attrIndexService.isCrossBoneKey]) {
                strokeColor = colors.mapError;
            }
            //
            var strokeWidth = feat.getProperties()[_this.attrIndexService.isFishboneRoadKey] ? styleAttrs.fishboneRoadStrokeWidth : styleAttrs.fishboneStrikeStrokeWidth;
            var baseStyle = new Style({
                image: new RegularShape({
                    fill: new Fill({
                        color: colors.mapError
                    }),
                    points: 20,
                    radius: 2,
                }),
                stroke: new Stroke({
                    color: strokeColor,
                    width: strokeWidth
                })
            });
            var styles = [baseStyle];
            // Arrow style // For fishbone road only
            if (feat.getProperties()[_this.attrIndexService.isFishboneRoadKey]) {
                var geomType = feat.getGeometry().getType();
                var as = _this.mapSharedService.getLineArrowStyle(feat, reso, geomType === 'MultiLineString', {
                    // img: 'arrowhead_icon.png',
                    color: imgFillColor,
                });
                if (as) {
                    styles.unshift(as);
                }
            }
            // // StartPointStyle
            // const startPointStyle = this.getFishboneStartPointStyle(feat);
            // if (startPointStyle) {
            // 	styles.unshift(startPointStyle);
            // }
            return styles;
        };
        this.getFishboneBgLayerStyle = function (feat, reso) {
            var imgFillColor = colors.mapSurroundingFill;
            var strokeColor = colors.mapSurroundingFill;
            //
            var strokeWidth = styleAttrs.fishboneRefStrokeWidth;
            //
            var baseStyle = new Style({
                image: new RegularShape({
                    fill: new Fill({
                        color: imgFillColor
                    }),
                    points: 20,
                    radius: 2,
                }),
                stroke: new Stroke({
                    color: strokeColor,
                    width: strokeWidth
                })
            });
            var styles = [baseStyle];
            // Arrow style // For fishbone road only
            if (feat.getProperties()[_this.attrIndexService.isFishboneRoadKey]) {
                var geomType = feat.getGeometry().getType();
                var as = _this.mapSharedService.getLineArrowStyle(feat, reso, geomType === 'MultiLineString', {
                    color: imgFillColor,
                    scale: 0.3
                });
                if (as) {
                    styles.unshift(as);
                }
            }
            return styles;
        };
        // On editing, change the style of irrelevant data (which isn't being edited) to a less stand-out style
        this.getIrrelevantDataLayerStyleOnEditing = function (feat) {
            var config = {};
            var styles = [];
            switch (feat.getGeometry().getType()) {
                // Use thinner stroke for polygon boundary
                case 'Polygon':
                case 'MultiPolygon':
                    config.strokeWidth = 2;
                    config.fillColor = config.fillColor || 'transparent';
                    break;
                case 'LineString':
                case 'MultiLineString':
                    config.strokeWidth = 1;
                    // Vertex Style:
                    var vertexStyle = _this.getVertextStyle(feat, {
                        radius: 2,
                        color: colors.mapFill,
                        strokeColor: colors.mapFill
                    });
                    styles.push(vertexStyle);
                    break;
                case 'Point':
                //
            }
            var common = _this.cMapService.getCommonStyle(config);
            styles.push(common);
            return styles;
        };
        this.getTopoErrorLayerStyle = function (feat) {
            var prop = feat.getProperties();
            return new Style({
                stroke: new Stroke({
                    color: prop[_this.attrIndexService.topoHexColorAttr],
                    width: prop[_this.attrIndexService.topoStrokeWidthAttr]
                }),
                image: new Circle({
                    radius: prop[_this.attrIndexService.topoRadiusAttr],
                    fill: new Fill({
                        color: prop[_this.attrIndexService.topoHexColorAttr]
                    })
                })
            });
        };
        this.getModifyLayerStyles = function (feat, reso, hideVertex) {
            // const highlightStyle = this.getBasicHighlightStyle();
            var featureStyle = new Style({
                image: new RegularShape({
                    fill: new Fill({
                        color: 'red'
                    }),
                    radius: 5,
                    points: 4
                }),
                stroke: new Stroke({
                    color: colors.mapFill,
                    width: 1
                }),
                fill: new Fill({
                    color: colors.mapFill_alpha
                })
            });
            var styles = [featureStyle]; // [highlightStyle, featureStyle];
            if (!hideVertex) {
                var vertexStyle = _this.getVertextStyle(feat);
                styles.push(vertexStyle);
            }
            // For address point being edited in relocation tool
            var forceShowLabel = feat.getProperties()[_this.attrIndexService.forceShowLabelKey];
            if (forceShowLabel) {
                var labelStyle = _this.getAddressLabelStyle(feat.getProperties(), [_this.attrIndexService.addrNumPrefixCol, _this.attrIndexService.addrRelocateNumCol, _this.attrIndexService.addrNumSuffixCol]);
                styles.push(labelStyle);
            }
            return styles;
        };
        this.getVertextStyle = function (feat, config) {
            var points = [];
            var geomType = feat.getGeometry().getType();
            if (geomType === 'Point') {
                points = [feat.getGeometry().getCoordinates()];
            }
            else if (geomType === 'MultiPoint' || geomType === 'LineString') {
                points = feat.getGeometry().getCoordinates();
            }
            else if (geomType === 'MultiLineString' || geomType === 'Polygon') {
                feat.getGeometry().getCoordinates().forEach(function (line) { return points = points.concat(line); });
            }
            else if (geomType === 'MultiPolygon') {
                feat.getGeometry().getCoordinates().forEach(function (polygon) {
                    polygon.forEach(function (line) { return points = points.concat(line); });
                });
            }
            // const vertexStyle = new Style({
            // 	image: new RegularShape({
            // 		stroke: new Stroke({
            // 			width: 0.7,
            // 			color: vertexColor
            // 		}),
            // 		// fill: new Fill({
            // 		// 	color: vertexColor
            // 		// }),
            // 		points: 4,
            // 		radius: 4,
            // 		angle: Math.PI / 4,
            // 		rotation: Math.PI / 4
            // 	}),
            // 	geometry: new MultiPoint(points)
            // });
            config = config || {};
            return new Style({
                image: new Circle({
                    radius: config.radius || 4,
                    fill: new Fill({
                        color: config.color || '#ccc'
                    }),
                    stroke: new Stroke({
                        width: 1.5,
                        color: config.strokeColor || colors.mapFill
                    })
                }),
                geometry: new MultiPoint(points)
            });
        };
        this.getBasicHighlightStyle = function () {
            var color = colors.highlight_alpha;
            var strokeWidth = 8;
            var basicStyle = new Style({
                image: new Circle({
                    radius: 10,
                    fill: new Fill({
                        color: color
                    })
                }),
                stroke: new Stroke({
                    width: strokeWidth,
                    color: color
                }),
                fill: new Fill({
                    color: color
                })
            });
            return basicStyle;
        };
        this.getDataSelectionStyle = function (feat, reso, currentStyles) {
            var styles;
            if (feat.getProperties()[_this.attrIndexService.isFeatOnModifyLayer]) {
                styles = _this.getModifyLayerStyles(feat);
            }
            else {
                var basicStyle = _this.getBasicHighlightStyle();
                basicStyle.setZIndex(0);
                currentStyles.forEach(function (s) {
                    if (s) {
                        s.setZIndex(1);
                    }
                });
                currentStyles.unshift(basicStyle);
                styles = currentStyles;
            }
            if (feat.getId() === _this.currentCardId) {
                var currentRecordStyle = _this.getCurrentDataStyle();
                currentRecordStyle.setZIndex(0);
                styles.unshift(currentRecordStyle);
            }
            return styles;
        };
        this.getCurrentDataStyle = function () {
            var color = colors.highlight_alpha_current;
            var strokeWidth = 14;
            return new Style({
                image: new Circle({
                    radius: 15,
                    fill: new Fill({
                        color: color
                    })
                }),
                stroke: new Stroke({
                    width: strokeWidth,
                    color: color
                }),
                fill: new Fill({
                    color: colors.highlight_alpha
                })
            });
        };
        this.getFishboneHighlightStyle = function (feat, reso) {
            var drawingStyles = _this.getInteractiveFishboneStyle(feat, reso);
            var basicStyle = _this.getBasicHighlightStyle();
            basicStyle.setZIndex(0);
            drawingStyles.forEach(function (s) {
                if (s) {
                    s.setZIndex(1);
                }
            });
            var styles = drawingStyles.concat(basicStyle);
            return styles;
        };
        this.setLabelFeatFlashStyle = function (feat) {
            var currStyle = feat.getStyle();
            var style1 = new Style({
                stroke: new Stroke({
                    color: colors.highlight_alpha,
                    width: 5
                })
            });
            var style2 = new Style({
                stroke: new Stroke({
                    color: colors.mapSurroundingFill,
                    width: 3
                })
            });
            var count = 0;
            var interval = setInterval(function () {
                if (count >= 4) {
                    feat.setStyle(currStyle);
                    clearInterval(interval);
                    return;
                }
                count++;
                if (count % 2) {
                    feat.setStyle(style1);
                }
                else {
                    feat.setStyle(style2);
                }
            }, 200);
        };
        this.getSameLocationPointStyle = function () {
            return new Style({
                image: new Circle({
                    stroke: new Stroke({
                        color: colors.mapFill,
                        width: 1,
                    }),
                    radius: 8,
                })
            });
        };
        this.setFeatureFlashStyle = function (feat, intervalTime) {
            intervalTime = intervalTime || 200;
            var currStyle = feat.getStyle();
            var style1 = new Style({
                stroke: new Stroke({
                    color: colors.highlight_alpha,
                    width: 5
                })
            });
            var style2 = new Style({
                stroke: new Stroke({
                    color: colors.mapSurroundingFill,
                    width: 3
                })
            });
            var count = 0;
            var interval = setInterval(function () {
                if (count >= 4) {
                    feat.setStyle(currStyle);
                    clearInterval(interval);
                    return;
                }
                count++;
                if (count % 2) {
                    feat.setStyle(style2);
                }
                else {
                    feat.setStyle(style1);
                }
            }, intervalTime);
        };
        // private getAddrFishboneLayerStyle = (feat, reso, isBg?: boolean) => {
        // 	const strokeColor = isBg ? colors.mapFill + '4D' : colors.mapFill;
        // 	const strokeWidth = 1;
        // 	const baseStyle = new Style({
        // 		// image: new RegularShape({
        // 		// 	fill: new Fill({
        // 		// 		color: colors.mapError
        // 		// 	}),
        // 		// 	points: 20,
        // 		// 	radius: 2,
        // 		// }),
        // 		stroke: new Stroke({
        // 			color: strokeColor,
        // 			width: strokeWidth
        // 		})
        // 	});
        // 	return baseStyle;
        // }
        this.getFishboneAddressStyle = function (fb, modelKey, isBg) {
            if (!fb) {
                return null;
            }
            modelKey = modelKey || 'N';
            var fbByModel = modelKey === 'L' ? fb.legacy : fb.nena;
            if (!fbByModel) {
                return null;
            }
            var fbCode = fbByModel.cd;
            var color1 = '#FF0000' + (isBg ? '4D' : '');
            var color2 = (isBg ? colors.mapSurroundingFill + '4D' : colors.mapFill);
            var startPointStyle = _this.getFishbonePointStyleByCode(fbCode, color1, color2);
            return startPointStyle;
        };
        this.getFishboneSpikeStyle = function (feat, reso, modelKey, isBg) {
            var props = feat.getProperties();
            var coords = feat.getGeometry().getCoordinates();
            var geomType = feat.getGeometry().getType();
            var coord;
            if (geomType === 'Point') {
                coord = coords;
            }
            else if (geomType === 'LineString') {
                coord = coords[0];
            }
            else if (geomType === 'MultiLineString') {
                coord = coords[0][0];
            }
            if (coord) {
                modelKey = modelKey || 'N';
                var geocodeCoordsByModel = props[_this.attrIndexService.fishboneGeocodeCoordsByModelKey];
                if (geocodeCoordsByModel && geocodeCoordsByModel[modelKey] && geocodeCoordsByModel[modelKey].length) {
                    var color2 = (isBg ? colors.mapSurroundingFill + '4D' : colors.mapFill);
                    var spikeStyle = new Style({
                        geometry: new MultiLineString(geocodeCoordsByModel[modelKey].map(function (geocodeCoord) { return [coord, geocodeCoord]; })),
                        stroke: new Stroke({
                            color: color2,
                            width: 1,
                            lineDash: [4, 8]
                        })
                    });
                    return spikeStyle;
                }
            }
        };
        // TODO: remove
        this.getFishboneAddressLayerStyle = function (feat, reso, modelKey, isBg) {
            // const props = feat.getProperties();
            // const coords = feat.getGeometry().getCoordinates();
            // const geomType = feat.getGeometry().getType();
            // let coord;
            // if (geomType === 'Point') {
            // 	coord = coords;
            // } else if (geomType === 'LineString') {
            // 	coord = coords[0];
            // } else if (geomType === 'MultiLineString') {
            // 	coord = coords[0][0];
            // }
            // if (coord) {
            // 	const styles = [];
            // 	// Address label style
            // 	const labelStyle = this.getAddressLabelStyle(props);
            // 	styles.push(labelStyle);
            // 	// Fishbone style
            // 	const fb: AddressFishboneInfo = props[this.attrIndexService.addrFishboneCol];
            // 	const startPointStyle = this.getFishboneAddressStyle(fb, modelKey);
            // 	if (startPointStyle) {
            // 		styles.push(startPointStyle);
            // 	}
            // 	//
            // 	const geocodeCoordsByModel: {[modelKey: string]: number[][]} = props[this.attrIndexService.fishboneGeocodeCoordsByModelKey];
            // 	if (geocodeCoordsByModel[modelKey] && geocodeCoordsByModel[modelKey].length) {
            // 		const spikeStyle = new Style({
            // 			geometry: new MultiLineString(geocodeCoordsByModel[modelKey].map(geocodeCoord => [coord, geocodeCoord])),
            // 			stroke: new Stroke({
            // 				color: color2,
            // 				width: 1
            // 			})
            // 		});
            // 		styles.push(spikeStyle);
            // 	}
            // 	return styles;
            // }
        };
        this.getAddressHintStyle = function (feat, reso, skipLabel) {
            var styles = [new Style({
                    image: new RegularShape({
                        fill: new Fill({
                            color: '#93d4ff'
                        }),
                        points: 20,
                        radius: 2,
                    }),
                    stroke: new Stroke({
                        color: '#93d4ff',
                        width: 2,
                        lineDash: [4, 8]
                    })
                })];
            if (!skipLabel && feat.getGeometry().getType() === 'Point') {
                var labelStyle = _this.getAddressLabelStyle(feat.getProperties());
                styles.push(labelStyle);
            }
            return styles;
        };
    }
    // #region Layers
    // Add vector tile reference layer
    // For getting tiles info
    MainDataMapLayersService.prototype.addRefVectorTileLayer = function (map, zIndex) {
        var options = {
            source: new VectorTileSource({
                format: new MVT(),
            })
        };
        if (zIndex) {
            options.zIndex = zIndex;
        }
        var layer = new VectorTileLayer(options);
        map.olMap.addLayer(layer);
        map.addedLayers[this.vectorTileRefLayerName] = layer;
    };
    MainDataMapLayersService.prototype.addDataLayer = function (map, zIndex) {
        map.addLayer(this.dataLayerName, {
            zIndex: zIndex++
        });
    };
    MainDataMapLayersService.prototype.addInteractiveFishboneLayer = function (map, zIndex) {
        map.addLayer(this.interactiveFishboneLayerName, {
            style: this.getInteractiveFishboneStyle,
            zIndex: zIndex++,
            maxResolution: this.interactiveFishboneReso
        });
    };
    // Topo errors: gap, overlap, crevice, fo, so
    MainDataMapLayersService.prototype.addTopologyErrorLayer = function (map, zIndex) {
        map.addLayer(this.topoErrorLayerName, {
            zIndex: zIndex,
            style: this.getTopoErrorLayerStyle
        });
    };
    MainDataMapLayersService.prototype.addTopologyResolvedLayer = function (map, zIndex) {
        var _this = this;
        map.addLayer(this.topoResolvedLayerName, {
            zIndex: zIndex,
            style: function (feat, reso) { return _this.setEventLayerStyles(reso, feat, { fillColor: '#cccccc80' }); } // TODO
        });
    };
    MainDataMapLayersService.prototype.addTopojsonLayer = function (map, zIndex) {
        var _this = this;
        map.addLayer(this.topojsonLayerName, {
            style: function (feat) {
                var styles = [];
                if (feat.getId() === _this.currentCardId) {
                    var currentRecordStyle = _this.getCurrentDataStyle();
                    styles.push(currentRecordStyle);
                }
                var withinEditLevel = map.addedLayers[_this.topojsonLayerName].getProperties()[_this.attrIndexService.topoLayerIsWithinEditResoKey];
                var modifyStyles = _this.getModifyLayerStyles(feat, null, !withinEditLevel);
                styles = styles.concat(modifyStyles);
                return styles;
            },
            sourceFormat: new TopoJSON({
                // url: 'https://openlayers.org/en/latest/examples/data/topojson/world-110m.json',
                layers: [this.topojsonFormatLayer]
            }),
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addAddPolygonTempLayer = function (map, zIndex) {
        map.addLayer(this.addPolygonTempLayerName, {
            style: new Style({
                stroke: new Stroke({
                    width: 5,
                    color: 'red'
                })
            }),
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addCursorLayer = function (map, zIndex) {
        map.addLayer(this.cursorLayerName, {
            style: new Style({
                image: new Icon({
                    src: 'assets/css/img/Small_cursor_pink.png',
                })
            }),
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addQcErrorLayer = function (map, zIndex) {
        var color = colors.mapError;
        map.addLayer(this.qcErrorLayerName, {
            style: this.cMapService.getCommonStyle({
                fillColor: color,
                imgFillColor: color,
                strokeColor: color,
                strokeWidth: 6,
                pointRadius: 6
            }),
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addFlashLayer = function (map, zIndex) {
        var color = '#FF000080';
        map.addLayer(this.flashLayerName, {
            style: this.cMapService.getCommonStyle({
                fillColor: color,
                imgFillColor: color,
                strokeColor: color,
                strokeWidth: 6,
                pointRadius: 6
            }),
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addDataModifyLayer = function (map, zIndex) {
        var _this = this;
        var layer = map.addLayer(this.dataModifyLayerName, {
            zIndex: zIndex,
            style: this.getModifyLayerStyles
        });
        var source = layer.getSource();
        var updateFeatAttr = function (feat, isOnModifyLayer) {
            var prop = feat.getProperties();
            prop[_this.attrIndexService.isFeatOnModifyLayer] = isOnModifyLayer;
            feat.setProperties(prop);
        };
        source.on('addfeature', function (e) {
            updateFeatAttr(e.feature, true);
        });
        source.on('removefeature', function (e) {
            updateFeatAttr(e.feature, false);
        });
        source.on('clear', function (e) {
            console.log(e);
        });
    };
    MainDataMapLayersService.prototype.addPlaceMarkerLayer = function (map, zIndex) {
        var layer = map.addLayer(this.placeMarkerLayerName, {
            style: new Style({
                image: new Icon({
                    src: 'assets/css/img/google-maps-marker.png',
                    scale: 0.5
                })
            }),
            zIndex: zIndex
        });
        layer.getSource().addFeature(new Feature());
    };
    MainDataMapLayersService.prototype.addAddressLineLayer = function (map, zIndex) {
        var layer = map.addLayer(this.addressLineLayerName, {
            style: this.getBasicHighlightStyle,
            zIndex: zIndex
        });
        return layer;
    };
    MainDataMapLayersService.prototype.addAddressManageLayer = function (map, zIndex) {
        var _this = this;
        var layer = map.addLayer(this.addressManageLayerName, {
            style: function (feat, reso) {
                var styles = _this.setEventLayerStyles(reso, feat);
                var labelStyle = _this.getAddressLabelStyle(feat.getProperties());
                styles.push(labelStyle);
                if (feat.getProperties()[_this.attrIndexService.sameLocationKey]) {
                    styles.push(_this.getSameLocationPointStyle());
                }
                return styles;
            },
            zIndex: zIndex
        });
        return layer;
    };
    MainDataMapLayersService.prototype.addAddressRelocateLineLayer = function (map, zIndex) {
        var _this = this;
        var layer = map.addLayer(this.addressRelocateHintLayerName, {
            style: function (feat, reso) { return _this.getAddressHintStyle(feat, reso, true); },
            zIndex: zIndex
        });
        return layer;
    };
    // For polygon delete highlight
    MainDataMapLayersService.prototype.addHighlightLayer = function (map, zIndex) {
        var layer = map.addLayer(this.highlightLayerName, {
            style: this.getBasicHighlightStyle,
            zIndex: zIndex
        });
        return layer;
    };
    // addAddrFishboneLayer(map: LRSMap.Map, zIndex?: number) {
    // 	const layer = map.addLayer(this.addrFishboneLayerName, {
    // 		style: this.getAddrFishboneLayerStyle,
    // 		zIndex: zIndex
    // 	});
    // 	return layer;
    // }
    // addAddrBgFishboneLayer(map: LRSMap.Map, zIndex?: number) {
    // 	const layer = map.addLayer(this.addrBgFishboneLayerName, {
    // 		style: (feat, reso) => this.getAddrFishboneLayerStyle(feat, reso, true),
    // 		zIndex: zIndex
    // 	});
    // 	return layer;
    // }
    // #region Reference layers And Surrounding layers
    MainDataMapLayersService.prototype.addBgSurroundingsLayer = function (map, zIndex) {
        map.addLayer(this.bgSurroundingsLayerName, {
            // style: (feat, reso) => {
            // 	const styles = this.getDataBgLayerStyle(feat, reso);
            // 	// Draw label for point
            // 	const geomType = feat.getGeometry().getType();
            // 	if (geomType === 'Point' && this.checkDrawAddrLabel(reso, map.addedLayers[this.bgSurroundingsLayerName])) {
            // 		const labelStyle = this.getAddressLabelStyle(feat.getProperties());
            // 		styles.push(labelStyle);
            // 	}
            // 	return styles;
            // },
            // maxResolution: this.refLayerResolution,
            zIndex: zIndex
        });
    };
    MainDataMapLayersService.prototype.addBgReferenceLayer = function (map, zIndex) {
        var layer = map.addLayer(this.bgReferenceLayerName, {
            // style: (feat, reso) => {
            // 	const styles = this.getDataBgLayerStyle(feat, reso);
            // 	// Draw label for point
            // 	const geomType = feat.getGeometry().getType();
            // 	if (geomType === 'Point' && this.checkDrawAddrLabel(reso, map.addedLayers[this.bgReferenceLayerName])) {
            // 		// const placement = geomType === 'Point' ? 'point' : 'line';
            // 		// const resoLimit = placement === 'line' ? this.labelResolution.ROADCL : this.labelResolution.ADDPTS; // TODO
            // 		styles.push(this.getAddressLabelStyle(feat.getProperties()));
            // 	}
            // 	return styles;
            // },
            zIndex: zIndex
        });
        // layer.getSource().on('clear', () => {
        // 	debugger
        // })
    };
    MainDataMapLayersService.prototype.addBgReferenceCountyBdryLayer = function (map, zIndex, zIndex2) {
        var thinStroke = new Stroke({
            width: 2,
            color: colors.mapFill,
        });
        // Add adjacent boundary layer
        map.addLayer(this.countyBoundaryLayerName, {
            style: new Style({
                stroke: thinStroke,
                fill: new Fill({
                    color: 'transparent'
                })
            }),
            zIndex: zIndex
        });
        // Add snap layer
        map.addLayer(this.countyBoundarySelfLayerName, {
            style: new Style({
                stroke: thinStroke
            }),
            zIndex: zIndex2
        });
        // Add snap
        var snap = new Snap({
            // features: new Collection({
            // 	array: features
            // })
            source: map.addedLayers[this.countyBoundarySelfLayerName].getSource(),
            edge: true,
        });
        map.olMap.addInteraction(snap);
    };
    // Topology layer
    MainDataMapLayersService.prototype.addBgOptionalBdryLayer = function (map, zIndex) {
        map.addLayer(this.bgOptionalBdryLayerName, {
            style: this.getDataBgLayerStyle,
            sourceFormat: new TopoJSON({
                layers: [this.topojsonFormatLayer]
            }),
            zIndex: zIndex
        });
    };
    // Background: Match Point
    MainDataMapLayersService.prototype.addBackgroundMatchPointLayer = function (map) {
        if (!map.addedLayers[this.bgReferenceEdgePointLayerName]) {
            var matchPointColor = colors.mapBgPointColor;
            map.addLayer(this.bgReferenceEdgePointLayerName, {
                style: new Style({
                    image: new Circle({
                        radius: 10,
                        fill: new Fill({
                            color: matchPointColor
                        })
                    })
                })
            });
        }
    };
    // removeBackgroundMatchPointLayer(map: LRSMap.Map) {
    // 	if (map.addedLayers[this.bgReferenceEdgePointLayerName]) {
    // 		map.olMap.removeLayer(map.addedLayers[this.bgReferenceEdgePointLayerName]);
    // 		delete map.addedLayers[this.bgReferenceEdgePointLayerName];
    // 	}
    // }
    // #endregion
    MainDataMapLayersService.prototype.setBgSurroundingsLayerMaxReso = function (map, layerCateCode) {
        var reso = this.refLayerResolution[layerCateCode] || 5;
        var layer = map.addedLayers[this.bgSurroundingsLayerName];
        layer.setMaxResolution(reso);
    };
    MainDataMapLayersService.prototype.setBgRefLayerMaxReso = function (map, layerCateCode, isBdryWizard) {
        var reso = this.refLayerResolution[layerCateCode] || 5;
        if (isBdryWizard) {
            reso = this.refCenterlineResoAtBdryEdit;
        }
        var layer = map.addedLayers[this.bgReferenceLayerName];
        layer.setMaxResolution(reso);
    };
    // #endregion
    // #region Styles
    // Return a style array
    MainDataMapLayersService.prototype.setEventLayerStyles = function (reso, feature, config, errLevel, skipArrow) {
        config = config || {};
        var styles = [];
        switch (feature.getGeometry().getType()) {
            // Use thinner stroke for polygon boundary
            case 'Polygon':
            case 'MultiPolygon':
                config.strokeWidth = config.strokeWidth || 2;
                config.fillColor = config.fillColor || 'transparent';
                return [this.cMapService.getCommonStyle(config)];
            case 'LineString':
            case 'MultiLineString':
                config.strokeWidth = 3;
                if (errLevel === 'CRITICAL') {
                    config.strokeColor = 'red';
                }
                else if (errLevel === 'WARNING') {
                    config.strokeColor = 'red';
                    config.lineDash = [2, 4];
                }
                var isMultiLine = feature.getGeometry().getType() === 'MultiLineString';
                // Common style
                var cs = this.cMapService.getCommonStyle(config);
                styles = [cs];
                if (!skipArrow) {
                    // Arrow style
                    var as = this.mapSharedService.getLineArrowStyle(feature, reso, isMultiLine, { color: cs.getStroke().getColor() });
                    if (as) {
                        styles.push(as);
                    }
                }
                return styles;
            case 'Point':
                var xStyle = void 0;
                if (errLevel === 'CRITICAL') {
                    config.imgFillColor = 'red';
                    config.pointRadius = 5;
                    xStyle = new Style({
                        image: new RegularShape({
                            fill: new Fill({
                                color: 'white'
                            }),
                            stroke: new Stroke({
                                color: 'white'
                            }),
                            points: 4,
                            radius: 10,
                            radius2: 0,
                            angle: Math.PI / 4,
                        })
                    });
                }
                else if (errLevel === 'WARNING') {
                    config.imgFillColor = 'red';
                    config.pointRadius = 5;
                    xStyle = new Style({
                        image: new RegularShape({
                            angle: 0,
                            fill: new Fill({
                                color: 'white'
                            }),
                            points: 3,
                            radius: 4,
                        })
                    });
                }
                styles = [this.cMapService.getCommonStyle(config)];
                if (xStyle) {
                    styles.push(xStyle);
                }
                // if (feature.getProperties()[this.cMapService.labelCol]) {
                // 	// Label style
                // 	const ls = this.cMapService.getLabelStyle(feature, null, config);
                // 	styles.push(ls);
                // }
                return styles;
            default:
                return [this.cMapService.getCommonStyle(config)];
        }
    };
    MainDataMapLayersService.prototype.getFishbonePointStyleByCode = function (fbCode, color1, color2) {
        var rCircleLarge = 5;
        var rCircleSmall = 4;
        var rDiamLarge = 6;
        var rDiamSmall = 4;
        var rTriaLarge = 10;
        var imgFillColor = 'black';
        var shape = 'circle';
        var radius;
        var startPointStyle;
        switch (fbCode) {
            case 'FS1':
            case 'FS1L':
                imgFillColor = color2;
                radius = rCircleSmall;
                break;
            case 'FS2':
            case 'FS2L':
                imgFillColor = color1;
                radius = rCircleSmall;
                break;
            case 'FS3':
            case 'FS3L':
                imgFillColor = color2;
                radius = rCircleLarge;
                break;
            case 'FS4':
            case 'FS4L':
                imgFillColor = color1;
                radius = rCircleLarge;
                break;
            case 'FS5':
            case 'FS5L':
                imgFillColor = color1;
                shape = 'diamond';
                radius = rDiamLarge;
                break;
            case 'FS6':
            case 'FS6L':
                imgFillColor = color1;
                shape = 'diamond';
                radius = rDiamLarge;
                break;
            case 'FS7':
            case 'FS7L':
                imgFillColor = color1;
                shape = 'diamond';
                radius = rDiamSmall;
                break;
            case 'FS8':
            case 'FS8L':
                imgFillColor = color1;
                shape = 'diamond';
                radius = rDiamSmall;
                break;
            case 'FS9':
            case 'FS9L':
                imgFillColor = color1;
                shape = 'triangle';
                radius = rTriaLarge;
                break;
            case 'FSA':
                imgFillColor = color2;
                shape = 'none';
                break;
            case 'FSB':
                imgFillColor = color2;
                shape = 'none';
                break;
        }
        switch (shape) {
            case 'circle':
                startPointStyle = new Style({
                    // geometry: new Point(coord),
                    image: new RegularShape({
                        fill: new Fill({
                            color: imgFillColor
                        }),
                        points: 20,
                        radius: radius,
                    }),
                    fill: new Fill({
                        color: imgFillColor
                    })
                });
                break;
            case 'diamond':
                startPointStyle = new Style({
                    // geometry: new Point(coord),
                    image: new RegularShape({
                        fill: new Fill({
                            color: imgFillColor
                        }),
                        points: 4,
                        radius: radius,
                        angle: Math.PI / 4,
                        rotation: Math.PI / 4
                    }),
                    fill: new Fill({
                        color: imgFillColor
                    })
                });
                break;
            case 'triangle':
                startPointStyle = new Style({
                    // geometry: new Point(coord),
                    image: new RegularShape({
                        angle: 0,
                        fill: new Fill({
                            color: imgFillColor
                        }),
                        points: 3,
                        radius: radius,
                    }),
                    fill: new Fill({
                        color: imgFillColor
                    })
                });
                break;
        }
        return startPointStyle;
    };
    MainDataMapLayersService.prototype.getLineLabelStyles = function (feat) {
        var props = feat.getProperties()[this.attrIndexService.attrKey] || {};
        var fromLeft = props[this.attrIndexService.fromAddrLeftColName];
        var fromRight = props[this.attrIndexService.fromAddrRightColName];
        var toLeft = props[this.attrIndexService.toAddrLeftColName];
        var toRight = props[this.attrIndexService.toAddrRightColName];
        var streetName = props[this.attrIndexService.rdStreetNameColName];
        var leftLabelText = fromLeft + " " + streetName + " " + toLeft;
        var rightLabelText = fromRight + " " + toRight;
        var leftLabelStyle = new Style({
            text: new Text({
                offsetY: 18,
                // offsetX: offsetX || 0,
                text: leftLabelText,
                font: 'Open Sans',
                // scale: 1.3,
                fill: new Fill({
                    color: 'red'
                }),
                textAlign: 'left',
                placement: 'line'
            })
        });
        var rightLabelStyle = new Style({
            text: new Text({
                offsetY: -18,
                // offsetX: offsetX || 0,
                text: rightLabelText,
                font: 'Open Sans',
                // scale: 1.3,
                fill: new Fill({
                    color: colors.mapLabel
                }),
                placement: 'line'
            })
        });
        return [leftLabelStyle, rightLabelStyle];
    };
    MainDataMapLayersService.prototype.checkDrawAddrLabel = function (reso, layer) {
        // if (reso > this.labelResolution.ADDPTS) {
        // 	return false;
        // } else if (reso < 0.3) { // zoom level 19
        // 	return true;
        // } else {
        // 	if (!layer.getProperties()[this.attrIndexService.drawAddrLabelKey]) {
        // 		return false;
        // 	} else {
        // 		return true;
        // 	}
        // }
        if (!layer.getProperties()[this.attrIndexService.drawAddrLabelKey]) {
            return false;
        }
        else {
            return true;
        }
    };
    MainDataMapLayersService.prototype.getAddressLabelStyle = function (attrs, cols, offsetX, offsetY) {
        // const props = isDataLayer ? feature.getProperties()[this.attrIndexService.attrKey] : feature.getProperties();
        cols = cols || [this.attrIndexService.addrNumPrefixCol, this.attrIndexService.addrLabelCol, this.attrIndexService.addrNumSuffixCol];
        var labelText = '';
        cols.forEach(function (col) {
            if (attrs[col]) {
                labelText += attrs[col] + '-';
            }
        });
        // Remove last '-'
        if (labelText) {
            labelText = labelText.substring(0, labelText.length - 1);
        }
        // if (!labelText && labelText !== 0) {
        // 	labelText = '';
        // }
        labelText = labelText.toString();
        return new Style({
            text: new Text({
                offsetY: offsetY || -18,
                offsetX: offsetX || 0,
                text: labelText,
                font: 'Open Sans',
                // scale: 1.3,
                fill: new Fill({
                    color: colors.mapLabel
                }),
                placement: 'point'
            })
        });
    };
    MainDataMapLayersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainDataMapLayersService_Factory() { return new MainDataMapLayersService(i0.ɵɵinject(i1.AttrIndexService), i0.ɵɵinject(i2.MainDataService), i0.ɵɵinject(i3.CommonMapService), i0.ɵɵinject(i4.MapSharedService)); }, token: MainDataMapLayersService, providedIn: "root" });
    return MainDataMapLayersService;
}());
export { MainDataMapLayersService };
